import { Component, OnInit } from '@angular/core';
import { getBrand } from 'src/environments/brand';

@Component({
  selector: 'ze-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.scss']
})
export class SchedulerComponent implements OnInit {
  brand = getBrand();

  constructor() { }

  ngOnInit() {
  }

}
